import { CloudOff, Loader2, RefreshCw } from 'lucide-react';

/**
 * Tells the technician the truth about where their taps are.
 *
 * Silence would be worse than an error: someone who does not know their work is
 * still on the phone will assume dispatch has seen it, and only find out when
 * they are asked why the job is still open.
 */
export function OfflineBar({
  online,
  queued,
  busy,
  onSync,
}: {
  online: boolean;
  queued: number;
  busy: boolean;
  onSync: () => void;
}) {
  if (online && queued === 0) return null;

  return (
    <div
      role="status"
      className={`flex items-center gap-2 px-5 py-2.5 text-sm ${
        online ? 'bg-accent-50 text-accent-600' : 'bg-muted text-foreground'
      }`}
    >
      {!online && <CloudOff className="h-4 w-4 shrink-0" aria-hidden="true" />}
      {busy && <Loader2 className="h-4 w-4 shrink-0 animate-spin" aria-hidden="true" />}

      <span className="flex-1">
        {!online && queued === 0 && 'No signal. Your work will be saved on this phone.'}
        {!online && queued > 0 && (
          <>
            No signal — <strong>{queued}</strong> saved here, {queued === 1 ? 'it' : 'they'} will
            send themselves.
          </>
        )}
        {online && queued > 0 && (
          <>
            Sending <strong>{queued}</strong> saved {queued === 1 ? 'action' : 'actions'}…
          </>
        )}
      </span>

      {online && queued > 0 && (
        <button
          type="button"
          onClick={onSync}
          disabled={busy}
          className="inline-flex shrink-0 items-center gap-1 font-semibold underline"
        >
          <RefreshCw className="h-3.5 w-3.5" aria-hidden="true" />
          Send now
        </button>
      )}
    </div>
  );
}
